import React from "react";
import "../styles/DisclaimerPage.css";

function DisclaimerPage() {
  return (
    <div className="disclaimer-wrapper">

      {/* HERO */}

      <section className="disclaimer-hero">

        <h1>Website Disclaimer</h1>

        <p>
          Important information regarding the usage, rights, and limitations
          of materials available on our website.
        </p>

      </section>



      {/* DISCLAIMER CONTENT */}

      <section className="disclaimer-content">

        <p>
          The contents and materials on the The Sahyadri Sahakari Bank Ltd.
          website are protected by copyright, trademark, and other applicable
          intellectual property and proprietary right laws and owned,
          controlled by, and/or licensed to The Sahyadri Sahakari Bank Ltd.
          Mumbai.
        </p>

        <p>
          You may download any of the contents or materials from the
          The Sahyadri Sahakari Bank Ltd. website for your personal use,
          but will make no other use of the contents or materials without
          the express written permission of The Sahyadri Sahakari Bank Ltd.
          or its authorized officers. You will not make any changes to the
          contents or materials that you download and you will not acquire
          any rights in any downloaded contents or materials.
        </p>

        <p>
          You will not reproduce, modify, publish, distribute, transfer,
          profit from the works, or in any way exploit any of the contents
          or materials, in whole or in part, found on the
          The Sahyadri Sahakari Bank Ltd. website. You will use the
          The Sahyadri Sahakari Bank Ltd. website and any contents or
          materials therein solely for your purpose for business.
        </p>

        <p>
          The Sahyadri Sahakari Bank Ltd. endeavors to ensure that the
          contents and materials included on the The Sahyadri Sahakari Bank
          Ltd. website are accurate, reliable, and complete. However,
          neither The Sahyadri Sahakari Bank Ltd. nor its directors,
          officers, employees, and agents warrant, represent, or guarantee
          the accuracy, reliability, and completeness of the contents and
          materials included on the The Sahyadri Sahakari Bank Ltd.
          website, including any other websites linked to or from the
          The Sahyadri Sahakari Bank Ltd. website.
        </p>

        <p>
          No reliance upon any parts thereof by you shall give rise to any
          claim whatsoever against The Sahyadri Sahakari Bank Ltd. Mumbai,
          its directors, officers, employees, and agents.
        </p>

        <p>
          To the extent permitted by applicable law, you will defend,
          indemnify, and hold The Sahyadri Sahakari Bank Ltd. Mumbai,
          its directors, officers, employees, and agents harmless from
          and against all claims, liabilities, and expenses arising out
          of your use of the The Sahyadri Sahakari Bank Ltd. website or
          your breach of any provisions herein.
        </p>

        <p>
          The Sahyadri Sahakari Bank Ltd. reserves the right to forthwith
          modify, add, remove, or amend any or all of the contents or
          materials on the The Sahyadri Sahakari Bank Ltd. website at
          any time at its absolute discretion.
        </p>

      </section>

    </div>
  );
}

export default DisclaimerPage;